import { useState, useCallback, useEffect } from 'react';

var clamp = function clamp(min, max, value) {
  return Math.max(min, Math.min(value, max));
};
var roundByStep = function roundByStep(value, step) {
  return step * Math.round(value / step);
};
var reverseFraction = function reverseFraction(fraction) {
  return Math.abs(clamp(0, 1, fraction) - 1);
};
var fractionFromPos = function fractionFromPos(orientation, rect, pos) {
  var offset = orientation === "horizontal" ? rect.left : rect.top;
  var length = orientation === "horizontal" ? rect.width : rect.height;
  var fraction = (pos - offset) / length;

  // Reverse percent if vertical
  if (orientation === "vertical") {
    return reverseFraction(fraction);
  }
  return fraction;
};
var useOnClickDrag = function useOnClickDrag(element, callback) {
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  var onDocumentRelease = function onDocumentRelease() {
    return setActive(false);
  };
  var onPosition = useCallback(function (x, y) {
    if (!element) {
      return;
    }
    callback({
      x: x,
      y: y
    });
  }, [callback, element]);
  var onClick = function onClick(e) {
    setActive(true);
    onPosition(e.clientX, e.clientY);
  };
  useEffect(function () {
    var onDocumentMouseMove = function onDocumentMouseMove(e) {
      if (!e.buttons || !active) {
        return;
      }
      onPosition(e.clientX, e.clientY);
    };
    var onDocumentTouchMove = function onDocumentTouchMove(e) {
      if (!active) {
        return;
      }
      e.preventDefault();
      onPosition(e.touches[0].pageX, e.touches[0].pageY);
    };
    if (active) {
      document.addEventListener("mousemove", onDocumentMouseMove);
      document.addEventListener("touchmove", onDocumentTouchMove);
      document.addEventListener("mouseup", onDocumentRelease);
      document.addEventListener("touchend", onDocumentRelease);
      return function () {
        document.removeEventListener("mousemove", onDocumentMouseMove);
        document.removeEventListener("touchmove", onDocumentTouchMove);
        if (onDocumentRelease) {
          document.removeEventListener("mouseup", onDocumentRelease);
          document.removeEventListener("touchend", onDocumentRelease);
        }
      };
    }
  }, [active, callback, onPosition]);
  return {
    onMouseDown: onClick,
    onTouchStart: onClick,
    isActive: active
  };
};

export { clamp, fractionFromPos, reverseFraction, roundByStep, useOnClickDrag };
//# sourceMappingURL=utils.js.map
